/** For setting a password (HA-458, security-policies §1). Existing shorter passwords still sign in. */
export const MIN_PASSWORD_LENGTH = 12;

const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{12,}$/;

export const validPassword = (password: string) => {
  return passwordRegex.test(password);
};
